<template>
    <div class="details-card">
        <div class="details-text">
            <div class="attribution-container attribution-with-legend">
                <div v-if="legendIcon != ''" class="attribution-spacing">
                    <span class="legend-icon">{{ legendIcon }}</span>
                </div>
                <a
                    :href="externalUrl"
                    class="wrap-text details-card-link"
                    target="_blank"
                    >{{ person?.objectLabel ?? person?.object }}
                    <img src="@/assets/external-link-blue.svg" />
                </a>
            </div>
            <div class="date-container">
                <span class="wrap-text">
                    <template v-if="showProperty(person?.birthDate)">
                        {{ convertDateStrings(person?.birthDate?.object) ?? "" }}
                    </template>
                    <template v-if="showProperty(person?.birthDate) && showProperty(person?.deathDate) && convertDateStrings(person?.birthDate?.object) && convertDateStrings(person?.deathDate?.object)">
                        -
                    </template>
                    <template v-if="showProperty(person?.deathDate)">
                        {{ convertDateStrings(person?.deathDate?.object) ?? "" }}
                    </template>
                </span>
            </div>
            <div class="note-container">
                <span class="wrap-text">
                    <template v-if="showProperty(person?.description)">
                        {{ person?.description?.object ?? "" }}
                    </template>
                    <a
                        v-if="person.hasOwnProperty('wikidataAttribution') && showWikidataAttribution"
                        class="attribution-container"
                        :href="person?.wikidataAttribution"
                        target="_blank"
                        :title="person?.wikidataAttribution"
                    >
                        <img
                            class="attribution-image"
                            src="@/assets/wikidata.png"
                        />
                    </a>
                </span>
            </div>
        </div>
        <div class="details-image">
            <img
                v-if="showProperty(person?.image) && person?.image?.object"
                :src="person?.image?.object"
            />
            <img
                v-else
                src="https://plugin.lincsproject.ca/cidoc-images/person.svg"
            />
        </div>
    </div>
</template>
<script lang="ts">
import { Vue, Options } from "vue-class-component";
@Options({
    props: {
        person: {
            type: Object,
            required: true,
        },
        legendIcon: {
            type: String,
            default: '',
        },
        datasetsToDisplay: {
            type: [Object, Array],
            default: () => ([]),
        },
        disableDatasetFilters: {
            type: Boolean,
            default: false,
        },
    },
})
class PersonDetailsCard extends Vue {
        get showWikidataAttribution() {
            // Only show if dataset filters are disabled or Wikidata is included
            if (this.disableDatasetFilters) return true;
            if (this.datasetsToDisplay) {
                if (Array.isArray(this.datasetsToDisplay) && this.datasetsToDisplay.includes('https://www.wikidata.org')) return true;
                if (typeof this.datasetsToDisplay === 'object' && Object.values(this.datasetsToDisplay).includes('https://www.wikidata.org')) return true;
            }
            return false;
        }
    person!: any;
    legendIcon!: string;
    datasetsToDisplay!: any;
    disableDatasetFilters!: boolean;

    get externalUrl() {
        if (!this.person?.object) return '';
        return 'https://rs-review.lincsproject.ca/resource/?uri=' + encodeURIComponent(this.person?.object);
    }

    convertDateStrings(date: string) {
        if (date != null) {
            return date.replace(/-/g, "/");
        }
        return null;
    }

    showProperty(prop: any) {
        if (!prop || !Object.hasOwn(prop, 'graph')) return true;
        if (this.disableDatasetFilters) return true;
        if (this.datasetsToDisplay && Array.isArray(this.datasetsToDisplay) && this.datasetsToDisplay.includes(prop.graph)) return true;
        if (this.datasetsToDisplay && typeof this.datasetsToDisplay === 'object' && Object.values(this.datasetsToDisplay).includes(prop.graph)) return true;
        return false;
    }
}
export default PersonDetailsCard;
</script>
<style>
.details-card {
    display: flex;
    position: relative;
    width: auto;
    align-items: center;
    justify-content: space-between;
    border-radius: 4px;
    border: 1px solid #ccc;
    padding-left: 12px;
}

.details-card:hover {
    border: 1px solid #ccc;
    background: #edf6f8;
}
.details-card.active {
    border: 1px solid #107386;
    background: #edf6f8;
}

.details-text {
    text-align: left;
    position: relative;
    flex: 1;
    padding-right: 10px;
    width: calc(100% - 80px);
    padding-top: 12px;
    padding-bottom: 12px;
}

.details-image {
    position: relative;
    display: flex;
    width: 75px;
    height: 100%;
}

.details-image img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.date-container {
    padding: 2px 0;
    color: #5e6364;
}

.note-container {
    padding-top: 4px;
    color: #333333;
}

.details-text span {
    position: relative;
    margin: 5px 0 0 0;
    font-size: 14px;
    font-weight: 400;
}

.attribution-with-legend {
    display: flex;
    align-items: center;
}

.attribution-spacing {
    margin-bottom: 4px;
    margin-right: 5px;
}
</style>
